import {
  ADD_TO_CART,
  CHANGE_QTY,
  REMOVE_FROM_CART,
  SHOW_CART_MODAL,
  HIDE_CART_MODAL,
  CLEAR_CART,
  SEND_CLEAR_CART,
  DECREMENT_QTY,
  GET_DELIVERY_COST,
  FILTER_CART,
  REFRESH_STORE
} from '../constants/action-types';
import { areNumericAttributesEqual, findExactProductMatch } from '../utils';
import { persistReducer, createTransform } from "redux-persist";
import storage from 'redux-persist/lib/storage';
import { getAdditionalPriceFromNumericAttributes } from '../utils/numericAttributes';

// Drop return-package data whose catalog entry no longer exists - it would crash cart views.
const sanitizeCartItem = (item) => {
  if (!item?.product_return_package || item.product_return_package.return_package) {
    return item;
  }

  const { product_return_package, ...rest } = item;
  return rest;
};

const sanitizeCartTransform = createTransform(
  null,
  (outboundState) => (Array.isArray(outboundState) ? outboundState.map(sanitizeCartItem) : outboundState),
  { whitelist: ['cart'] }
);

let initialState = {
  cart: [],
  deliveryCost: null,
  modalProduct: '',
  showModal: false
};

const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TO_CART:
      const existingProduct = findExactProductMatch(state.cart, action.product);

      if (existingProduct) {
        const cart = state.cart.map(product => {
          if (product === existingProduct) {
            const additionalPriceFromNumericAttributes = getAdditionalPriceFromNumericAttributes(product);
            return {
              ...product,
              qty: Number(product.qty) + action.qty,
              sum: ((action.product.prices.promo_on ? action.product.prices.promo_price : action.product.prices.promo_price) + additionalPriceFromNumericAttributes) * (product.qty + action.qty)
            };
          }
          return product;
        });

        return { ...state, cart };
      }

      return {
        ...state,
        cart: [
          ...state.cart,
          {
            ...sanitizeCartItem(action.product),
            qty: action.qty,
            sum: (parseFloat(action.product.prices.promo_on ? action.product.prices.promo_price : action.product.prices.promo_price) + getAdditionalPriceFromNumericAttributes(action.product)) * action.qty
          }
        ]
      };

    case CHANGE_QTY:
      const existingProductForQtyChange = findExactProductMatch(state.cart, action.product);

      if (existingProductForQtyChange) {
        const cart = state.cart.map(product => {
          if (product === existingProductForQtyChange) {
            return {
              ...product,
              qty: action.qty,
              sum: (parseFloat(action.product.prices.promo_on ? action.product.prices.promo_price : action.product.prices.promo_price) + getAdditionalPriceFromNumericAttributes(action.product)) * action.qty
            };
          }
          return product;
        });

        return { ...state, cart };
      }

      return {
        ...state,
        cart: [
          ...state.cart,
          {
            ...action.product,
            qty: action.qty,
            sum: (parseFloat(action.product.prices.promo_on ? action.product.prices.promo_price : action.product.prices.promo_price) + getAdditionalPriceFromNumericAttributes(action.product)) * action.qty
          }
        ]
      };

    case REMOVE_FROM_CART:
      return {
        ...state,
        cart: state.cart.filter(item => !areNumericAttributesEqual(item, action.product) || item.product_variant_id !== action.product.product_variant_id || item.product_id !== action.product.product_id)
      };

    case CLEAR_CART:
      return {
        ...state,
        cart: []
      };

    case SEND_CLEAR_CART:
      return {
        ...state,
        cart: []
      };

    case DECREMENT_QTY:
      const cart = state.cart.map(product => {
        if (product.product_variant_id === action.product.product_variant_id &&
          product.product_id === action.product.product_id &&
          areNumericAttributesEqual(product, action.product)) {
          return {
            ...product,
            qty: product.qty - 1,
            sum: (parseFloat(action.product.prices.promo_on ? action.product.prices.promo_price : action.product.prices.promo_price) + getAdditionalPriceFromNumericAttributes(action.product)) * (product.qty - 1)
          };
        }
        return product;
      });

      return { ...state, cart };

    case SHOW_CART_MODAL:
      return {
        ...state,
        showModal: true,
        modalProduct: action.product
      };

    case HIDE_CART_MODAL:
      return {
        ...state,
        showModal: false
      };

    case GET_DELIVERY_COST:
      return { ...state, deliveryCost: action.deliveryCost };

    case FILTER_CART:
      const { archedEdges, fences1, fences2 } = action.id;

      return {
        ...state,
        cart: state.cart.filter(item =>
          item.product_id === archedEdges ||
          item.product_id === fences1 ||
          item.product_id === fences2
        )
      };

    case REFRESH_STORE:
      return initialState;

    default:
      return state;
  }
};

const persistConfig = {
  keyPrefix: "buduj-",
  key: "cartlist",
  storage,
  transforms: [sanitizeCartTransform]
};

export default persistReducer(persistConfig, cartReducer);